import type { ReactElement } from 'react'

import { Loader } from '@/ui'
import { useLoadedFlagValue } from '@/utils/sharedHooks'
import { FEATURE_FLAG_KEYS } from '@/features/open-feature'
import { HavenCubkLanding } from './HavenCubkLanding'
import { LiveOnboardingBooking } from './live-onboarding/LiveOnboardingBooking'
import { useLiveOnboardingEligibility } from './live-onboarding/useLiveOnboardingEligibility'
import { SetupLandingCard } from './SetupLandingCard'

export const SetupLanding = (): ReactElement => {
  const havenCubkEnabled = useLoadedFlagValue(
    FEATURE_FLAG_KEYS.enableHavenCubk,
    false
  )
  const showLiveBooking = useLoadedFlagValue(
    FEATURE_FLAG_KEYS.showLiveOnboardingBooking,
    false
  )
  const showsHavenLanding = Boolean(havenCubkEnabled)
  const { eligibility, skip } = useLiveOnboardingEligibility(
    showLiveBooking === true && !showsHavenLanding
  )

  // Rendering on the default before flags load mounts the old page first,
  // which logs its page view for members who never see it.
  if (havenCubkEnabled === null || showLiveBooking === null)
    return <Loader active />
  if (showsHavenLanding) return <HavenCubkLanding />
  if (eligibility === 'loading') return <Loader active />
  if (eligibility === 'eligible') return <LiveOnboardingBooking onSkip={skip} />
  return <SetupLandingCard />
}
